import React from 'react';
import { Row } from './Layout';

interface PageHeaderProps {
    title: React.ReactNode;
    subtitle?: string;
    onDrawer?: () => void;
    onBack?: () => void;
    right?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, onDrawer, onBack, right, subtitle }) => {
    return (
        <div style={{ padding: '50px 18px 12px', flexShrink: 0 }}>
            <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Row style={{ gap: 10, alignItems: 'center' }}>
                    {onBack ? (
                        <button onClick={onBack} className="icon-btn">←</button>
                    ) : onDrawer ? (
                        <button onClick={onDrawer} style={{
                            width: 38, height: 38, background: 'var(--surface)', border: '1px solid var(--border)',
                            borderRadius: 11, cursor: 'pointer', display: 'flex', flexDirection: 'column',
                            alignItems: 'center', justifyContent: 'center', gap: 4, padding: '9px 10px', transition: 'all .2s'
                        }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface2)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'var(--surface)'}>
                            <div style={{ width: 16, height: 2, background: 'var(--text)', borderRadius: 2 }} />
                            <div style={{ width: 12, height: 2, background: 'var(--coral)', borderRadius: 2 }} />
                            <div style={{ width: 16, height: 2, background: 'var(--text)', borderRadius: 2 }} />
                        </button>
                    ) : null}
                    <div>
                        {subtitle && <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 1 }}>{subtitle}</div>}
                        <div className="syne" style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-.02em', lineHeight: 1 }}>{title}</div>
                    </div>
                </Row>
                {right && <Row style={{ gap: 8 }}>{right}</Row>}
            </Row>
        </div>
    );
};
